export default __webpack_public_path__ + "static/media/payments.3b37bd22.png";